import React, { PureComponent } from "react";
import _ from "lodash";
import Slider from "react-slick";
import { ClickMove } from ".";

const PrevArrow = props => {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <i className="fa fa-angle-left" aria-hidden="true" />
    </div>
  );
};

const NextArrow = props => {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <i className="fa fa-angle-right" aria-hidden="true" />
    </div>
  );
};

export default class MySlider extends PureComponent {
  constructor(props) {
    super(props);
    this.sliderRef = React.createRef();
  }
  state = {
    canClickItem: true
  };
  setCanClickItem = canClickItem => {
    if (this.state.canClickItem !== canClickItem) {
      this.setState({ canClickItem });
    }
  };
  handleClickMove = onClickMove => {
    this.setCanClickItem(!onClickMove);
  };
  render() {
    const { canClickItem } = this.state;
    const { className, items, uiRenderer, settings } = this.props;
    return (
      <ClickMove onClickMove={this.handleClickMove}>
        <div className="slider-component">
          <Slider
            className={className}
            ref={this.sliderRef}
            infinite={false}
            dots
            customPaging={i => <i className="fa fa-circle" aria-hidden="true" />}
            prevArrow={<PrevArrow />}
            nextArrow={<NextArrow />}
            swipeToSlide
            touchThreshold={8}
            pauseOnDotsHover
            pauseOnFocus
            pauseOnHover
            responsive={[
              {
                breakpoint: 767.98,
                settings: {
                  slidesToShow: 1,
                  arrows: false,
                  centerMode: true
                }
              }
            ]}
            {...settings}
          >
            {_.map(items, (item, key) => {
              return (
                <div key={key}>
                  <div style={{ pointerEvents: canClickItem ? "initial" : "none" }}>
                    {uiRenderer(item)}
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>
      </ClickMove>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Slider.js